export const COMPANIES_ID_TOKEN = 'COMPANIES_ID_TOKEN';

const initialState = null;

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case COMPANIES_ID_TOKEN:
            return action.payload;
        default:
            return state;
    }
};

const storeName = "companiesIdToken";
const storeMapping = { [storeName]: reducer };

export const companiesIdTokenSelector = (state) => state[storeName];

export default storeMapping; 
